const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBtnAttendantXs(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 1351",
    d: "M350.479 259.222c-6.4 0-6.42-.014-6.7-.226a1 1 0 0 1-.392-.794c0-3.409 3.813-6.181 8.5-6.181s8.5 2.772 8.5 6.181a1 1 0 0 1-.4.8c-.293.223-.293.223-8.1.224zm-4.9-2.009c2.773.01 9.833.011 12.616 0-.712-1.808-3.312-3.192-6.308-3.192s-5.595 1.379-6.306 3.192z",
    transform: "translate(-339.389 -237.222)",
    style: {
      fill: "current"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 1352",
    d: "M351.889 250.141a5.459 5.459 0 1 1 5.528-5.459 5.5 5.5 0 0 1-5.528 5.459zm0-8.918a3.46 3.46 0 1 0 3.528 3.459 3.5 3.5 0 0 0-3.528-3.459z",
    transform: "translate(-339.389 -237.222)",
    style: {
      fill: "current"
    }
  }));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnAttendantXs);
export default __webpack_public_path__ + "static/media/btn-attendant-xs.a974af9a32e11c0ad39e293dcc69f571.svg";
export { ForwardRef as ReactComponent };